module.exports = __webpack_public_path__ + "static/media/notVerifiedUser.af830405.svg";